<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">
        <v-toolbar tabs fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Inquiry</v-toolbar-title>
            <v-toolbar-title v-else>Edit Inquiry - {{selectedItem.project_number}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tabs slot="extension"
                    v-model="activeTab"
                    color="secondary"
                    dark
                    slider-color="primary"
                    class="fixSides"
                    show-arrows

            >
                <!--Neuen auftrag anlegen-->

                <v-tab>Inquiry</v-tab>

                <!--Supplier Inquiry Position Mapping-->
                <v-tab :disabled="tabsDisabled">Inquiry Positions</v-tab>

                <!--Supplier Requests-->
                <v-tab :disabled="tabsDisabled">SUPPLIER OFFER REQUESTS</v-tab>

                <!--Angebote eintragen-->
                <v-tab :disabled="tabsDisabled">SUPPLIER OFFERS</v-tab>

            </v-tabs>

            <v-toolbar-items>
                <v-menu
                        transition="slide-y-transition"
                        :nudge-bottom="20"
                        :nudge-right="0"
                        :nudge-left="0">
                    <v-btn @click="openBottomSheet($vuetify.breakpoint.mdAndDown)" id="menu-button"
                           slot="activator"
                           icon>

                        <v-icon dark>more_vert</v-icon>
                    </v-btn>
                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                        <v-list-tile @click.native="saveAll()">
                            <v-list-tile-title>
                                <v-icon color="secondary">save</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                        <v-list-tile @click.native="deleteAll()">
                            <v-list-tile-title>
                                <v-icon color="red">delete</v-icon>
                            </v-list-tile-title>
                        </v-list-tile>
                    </v-list>
                </v-menu>
            </v-toolbar-items>

        </v-toolbar>

        <v-tabs-items class="fromTop" v-model="activeTab"
                      :touchless="touchless">
            <v-tab-item>

                <v-layout v-if="dialog && activeTab === 0"  wrap>
                    <v-container grid-list-md>
                        <v-flex xs12 md10 offset-md1 xl6 offset-xl3>
                            <v-hover>
                                <v-card slot-scope="{ hover }"
                                        :class="`elevation-${hover ? 4 : 1}`">
                                    <v-card-title class="headline">{{cardTitle}} Inquiry
                                        <v-spacer></v-spacer>
                                        <v-autocomplete
                                                :disabled="selectedItem.id <= 0"
                                                :items="inquiryStatuses"
                                                item-text="name"
                                                item-value="id"
                                                label="Inquiry Status"
                                                v-model="selectedItem.inquiries_status_id"
                                                required
                                        ></v-autocomplete>
                                    </v-card-title>

                                    <v-card-title>

                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>Customer</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getCustomers"
                                                            label="Customer"
                                                            :search-input.sync="searchCustomer"
                                                            v-model="selectedCustomer"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >
                                            </v-autocomplete>
                                        </v-flex>


                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getCustomerBranchOffices"
                                                            label="Branch Office"
                                                            :search-input.sync="searchCustomerBranchOffice"
                                                            v-model="selectedCustomerBranchOffice"
                                                            :loading="loading"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >
                                            </v-autocomplete>
                                        </v-flex>

                                        <v-flex xs12 md12 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-autocomplete v-show="!getInitialLoading"
                                                            clearable
                                                            :items="getCustomerBranchOfficesContacts"
                                                            label="Contact Person"
                                                            :search-input.sync="searchCustomerBranchOfficeContact"
                                                            v-model="selectedCustomerBranchOfficeContact"
                                                            :loading="loading"
                                                            :filter="customContactFilter"
                                                            hide-details
                                                            item-value="id"
                                                            item-text="name"
                                            >

                                                <template slot="selection" slot-scope="data">
                                                    {{ data.item.title }} {{ data.item.firstname }} {{
                                                    data.item.lastname }}
                                                </template>

                                                <template slot="item" slot-scope="data">
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                        >
                                                            {{ data.item.title }} {{ data.item.firstname }} {{
                                                            data.item.lastname }}
                                                        </v-list-tile-title>
                                                        <!-- <v-list-tile-sub-title>
                                                             {{ data.item.email }}
                                                         </v-list-tile-sub-title>-->
                                                    </v-list-tile-content>
                                                </template>


                                            </v-autocomplete>
                                        </v-flex>


                                        <v-flex xs12 pr-3 pl-3>
                                            <v-subheader>RFQ</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-text-field v-show="!getInitialLoading"
                                                          v-model="rfqNumber"
                                                          label="RFQ Number"
                                                          data-vv-name="name"
                                                          required
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md6 pl-4 pa-2>
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <DatetimePicker v-show="!getInitialLoading"
                                                            locale="de-DE"
                                                            landscape
                                                            mysql
                                                            :width="width = 500"
                                                            label="Project Deadline"
                                                            format="DD.MM.YYYY HH:mm"
                                                            v-model="deadline">
                                            </DatetimePicker>
                                        </v-flex>

                                        <v-flex xs12 pr-3 pl-3 v-if="checkCustomerComment(customer_comment)">
                                            <v-subheader>Customer Comment</v-subheader>
                                            <v-divider></v-divider>
                                        </v-flex>

                                        <v-flex xs12 pl-4 pa-2  v-if="checkCustomerComment(customer_comment)">
                                            <FakeItem v-show="getInitialLoading">
                                            </FakeItem>
                                            <v-textarea v-show="!getInitialLoading"
                                                    auto-grow
                                                    rows="4"
                                                    label="Customer Comment"
                                                    v-model="customer_comment"
                                                    counter
                                                    readonly
                                            ></v-textarea>
                                        </v-flex>

                                        <ProcessHistory
                                                v-show="selectedItem.id > 0"
                                                :historyTypeID="selectedItem.histories_types_id"
                                                :itemID="selectedItem.id"
                                                :selectedItem="selectedItemForHistory"
                                        />

                                    </v-card-title>
                                    <v-card-actions>
                                        <v-layout mt-2 pb-3 pr-3>
                                            <v-spacer></v-spacer>
                                            <v-btn dark color="secondary" @click.native="saveInquiryAndGoToNextTab(1)">
                                                Save
                                                <v-icon class="white--text" right>save</v-icon>
                                            </v-btn>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-hover>
                        </v-flex>

                        <v-layout mt-5 row justify-end>

                        </v-layout>


                    </v-container>
                </v-layout>
            </v-tab-item>
            <v-tab-item>
                    <inquirySuppliers v-if="activeTab === 1"></inquirySuppliers>
            </v-tab-item>
            <v-tab-item>
                <inquirySupplierRequest v-if="activeTab === 2"></inquirySupplierRequest>
            </v-tab-item>
            <v-tab-item>
                <supplierOffersinquiryPositions v-if="activeTab === 3"></supplierOffersinquiryPositions>
            </v-tab-item>
        </v-tabs-items>

    </v-card>

</template>

<script>
    import {
        Settings,
        Inquiry,
        InquiryPosition,
        Customer,
        CustomerBranchOffice,
        CustomerBranchOfficeContact
    } from '../../store/namespace-helper'

    import inquirySuppliers from '../Distribution/Supplier/InquirySuppliers.vue'
    import inquirySupplierRequest from '../Distribution/SupplierRequests/InquirySupplierRequests.vue'
    import supplierOffersinquiryPositions from '../Distribution/SupplierOffer/SupplierOffersInquiryPositions.vue'
    import DatetimePicker from '../Shared/DatetimePicker.vue'
    import ProcessHistory from '../Shared/ProcessHistory.vue'
    import FakeItem from '../Shared/FakeItem.vue'
    import FakeTable from '../Shared/FakeTable.vue'

    import {initialLoadingMixin} from '../../mixins/initialLoadingMixin'

    import _ from 'lodash'

    export default {
      components: {
        inquirySuppliers,
        inquirySupplierRequest,
        supplierOffersinquiryPositions,
        DatetimePicker,
        ProcessHistory,
        FakeItem,
        FakeTable
      },
      name: 'add-inquiry',
      mixins: [initialLoadingMixin],
      data () {
        return {
          activeTab: 0,
          touchless: true,
          countries: this.$store.getters.countries,
          salutions: [
            'Mr.',
            'Mrs.',
            'Company'
          ],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          },
          isVisible: false,
          supplierContact: {},
          supplierUpdated: 0,
          onDismissed: false,
          sheet: false,
          searchCustomer: '',
          selectedCustomer: null,
          searchCustomerBranchOffice: '',
          selectedCustomerBranchOffice: '',
          searchCustomerBranchOfficeContact: '',
          selectedCustomerBranchOfficeContact: '',
          deadline: '',
          rfqNumber: '',
          inquiryStatuses: [],
          selectedItemForHistory: null,
          customer_comment: null

        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadInquiryStatus()
              this.loadSelectedItemForHistory()
              this.initialLoadingTimeout(850)
              this.$echo.private('request-created-chan.' + this.selectedItem.id).listen('SupplierRequestsCreated', (payload) => {
                console.log('message sent event: ' + JSON.stringify(payload))
                if (payload.data.error === false) {
                  this.activeTab = 2
                }
              })
            } else {
              this.supplierUpdated = 0
              this.resetInitialLoadingState()
            }
          }
        },
        closeDialog () {
          this.leaveChannel()
          this.activeTab = 0
          this.$store.dispatch(Inquiry.actions.setSelectedInquiry, null)
          this.$store.dispatch(Customer.actions.setSelectedCustomer, null)
          this.$store.dispatch(CustomerBranchOffice.actions.setSelectedBranchOffice, null)
          this.$store.dispatch(InquiryPosition.actions.resetAllInquiriesPositions)
          this.$store.dispatch(Inquiry.actions.openCloseInquiryDialog)
        },
        loadCustomers () {
          const query = {
            search: this.searchCustomer ? this.searchCustomer : ''
          }
          this.$store.dispatch(Customer.actions.loadCustomers, query)
        },
        loadInquiryStatus () {
          this.$store.dispatch(Inquiry.actions.loadInquiryStatus).then(response => {
            this.inquiryStatuses = response.data.data
          })
        },
        throttledLoadItems: _.debounce(function () {
          this.loadCustomers()
        }, 450),
        loadCustomerBranchOffices () {
          this.$store.dispatch(CustomerBranchOffice.actions.loadCustomerBranchOffices, this.selectedCustomer)
        },
        loadCustomerBranchOfficesContacts () {
          this.$store.dispatch(CustomerBranchOfficeContact.actions.loadContactPersons, this.selectedCustomerBranchOffice)
        },
        saveInquiryAndGoToNextTab (index) {
          let inquiry = {
            id: this.selectedItem.id,
            customers_id: this.selectedCustomer,
            customers_branch_offices_id: this.selectedCustomerBranchOffice,
            customers_branch_offices_contacts_id: this.selectedCustomerBranchOfficeContact,
            rfq_number: this.rfqNumber.replace(/[^a-z0-9]/gi, ''),
            deadline: this.deadline,
            inquiries_status_id: this.selectedItem.inquiries_status_id
          }

          this.$store.dispatch(Inquiry.actions.saveInquiries, inquiry).then(response => {
            this.loadSelectedItemForHistory()
            this.activeTab = index
          })
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        leaveChannel () {
          this.$echo.leave('request-created-chan.' + this.selectedItem.id)
        },
        loadSelectedItemForHistory () {
          if (this.selectedItem.id > 0) {
            this.$store.dispatch(Inquiry.actions.loadInquiry, this.selectedItem).then(response => {
              this.selectedItemForHistory = response.data.data
            })
          }
        },
        checkCustomerComment (val) {
          if (val) {
            if (val.length > 0) {
              return true
            }
          }

          return false
        }

      },
      computed: {
        dialog () {
          return this.$store.getters[Inquiry.getters.getOpenInquiryDialogState]
        },
        selectedItem () {
          console.log('selected Inquiry: ' + JSON.stringify(this.$store.getters[Inquiry.getters.getSelectedInquiry]))

          this.selectedCustomer = this.$store.getters[Inquiry.getters.getSelectedInquiry].customers_id
          this.selectedCustomerBranchOffice = this.$store.getters[Inquiry.getters.getSelectedInquiry].customers_branch_offices_id
          this.selectedCustomerBranchOfficeContact = this.$store.getters[Inquiry.getters.getSelectedInquiry].customers_branch_offices_contacts_id
          this.rfqNumber = this.$store.getters[Inquiry.getters.getSelectedInquiry].rfq_number
          this.deadline = this.$store.getters[Inquiry.getters.getSelectedInquiry].deadline
          this.customer_comment = this.$store.getters[Inquiry.getters.getSelectedInquiry].customer_comment

          return this.$store.getters[Inquiry.getters.getSelectedInquiry]
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        getCustomers () {
          return this.$store.getters[Customer.getters.customers]
        },
        getCustomerBranchOffices () {
          return this.$store.getters[CustomerBranchOffice.getters.getCustomerBranchOffices]
        },
        getCustomerBranchOfficesContacts () {
          return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        tabsDisabled () {
          return this.$store.getters[Inquiry.getters.getSelectedInquiry].id === 0
        },
        cardTitle () {
          if (this.selectedItem.id === 0) {
            return 'Add new'
          } else {
            return 'Edit'
          }
        }
      },
      watch: {
        searchCustomer: {
          handler (val) {
            console.log('searchCustomer data changed: ' + JSON.stringify(val))
            this.throttledLoadItems()
          },
          deep: true

        },
        selectedCustomer: {
          handler (val) {
            console.log('selectedCustomer data changed: ' + JSON.stringify(val))
            this.loadCustomerBranchOffices()
          },
          deep: true

        },
        selectedCustomerBranchOffice: {
          handler (val) {
            console.log('selectedCustomerBranchOffice data changed: ' + JSON.stringify(val))
            this.loadCustomerBranchOfficesContacts()
          },
          deep: true

        },
        activeTab: {
          handler (val) {
            if (val === 0) {
              this.loadSelectedItemForHistory()
            }
          }
        }
      }

    }
</script>


<style scoped>

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: var(--secondary-color);
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

</style>



// WEBPACK FOOTER //
// src/components/Shared/AddInquiry.vue